function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ajax, nodeArray, attach } from 'meteora';

// import ajax from '../functions/ajax';
import lastInRow from '../functions/last-in-row';
var AccordionGrid = /*#__PURE__*/function () {
  function AccordionGrid(el) {
    var _this = this;
    _classCallCheck(this, AccordionGrid);
    this.container = el;
    this.items = this.getItems();
    this.holder = document.createElement('div');
    this.detailsArray = [];
    this.timeout = null;
    this.events();
    attach(window, 'resize', function () {
      return _this.close();
    }, 500);
  }
  _createClass(AccordionGrid, [{
    key: "update",
    value: function update() {
      this.items = this.getItems();
      this.events();
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return nodeArray(this.container.querySelectorAll('.js-accordion-grid--item'));
    }
  }, {
    key: "events",
    value: function events() {
      var _this2 = this;
      this.items.forEach(function (item, i) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(_this2.timeout);
          item.classList.contains('js-active') ? _this2.close() : _this2.open(item, i);
        });
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.items.forEach(function (item) {
        return item.classList.remove('js-active');
      });
      this.detailsArray.forEach(function (details) {
        details.style.height = 0 + 'px';
        setTimeout(function () {
          return details.remove();
        }, 300);
      });
      this.detailsArray = [];
    }
  }, {
    key: "open",
    value: function open(item, i) {
      var _this3 = this;
      var holder = document.createElement('div');
      var height = 0;
      var details = null;
      var last = lastInRow(this.items, i);
      var api = item.getAttribute('data-api');
      if (api !== undefined && api !== null) {
        this.close();
        this.timeout = setTimeout(function () {
          ajax({
            url: item.getAttribute('data-api'),
            method: 'GET',
            success: function success(response) {
              _this3.close();
              item.classList.add('js-active');
              holder.innerHTML = JSON.parse(response).data.item;
              details = holder.firstChild;
              _this3.detailsArray.push(details);
              last.parentNode.parentNode.insertBefore(details, last.parentNode.nextSibling);
              height = details.clientHeight;
              details.style.height = 0 + 'px';
              setTimeout(function () {
                return details.style.height = height + 'px';
              }, 10);
            }
          });
        }, 300);
      }
    }
  }]);
  return AccordionGrid;
}();
;
export default AccordionGrid;